import { module } from 'modujs';
import gsap from 'gsap';
import { SplitText } from '../vendor/gsap-esm/SplitText';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.FX = {
      content: new SplitText(this.DOM.view, {
        type: 'words',
        wordsClass: 'tw-translate-x-[30px]',
      }),
    };

    gsap.delayedCall(window.readyDelay, () => {
      this.fx();
    });
  }

  fx() {
    this.animate();

    this.reveal();
  }

  animate() {
    this.animation = gsap.timeline();

    const segments = Math.ceil(this.FX.content.words.length / 25);
    this.parts = [];
    for (let index = 0; index < segments; index++) {
      let start = index * 25;
      let end = start + 25;
      this.parts.push(this.FX.content.words.slice(start, end));
    }

    for (let [i, part] of this.parts.entries()) {
      if (i == 0) {
        this.animation.add([
          gsap.to(part, {
            autoAlpha: 0,
            duration: 0,

            ease: 'linear',
            stagger: 0.02,
          }),
        ]);
      }
      if (typeof this.parts[i + 1] != 'undefined') {
        this.animation.add([
          gsap.to(part, {
            autoAlpha: 1,
            duration: 0,
            x: 0,
            ease: 'linear',
            stagger: 0.02,
          }),
          gsap.to(this.parts[i + 1], {
            autoAlpha: 0,
            duration: 0,

            ease: 'linear',
            stagger: 0.02,
          }),
        ]);
        this.animation.add(
          [
            gsap.to(this.parts[i + 1], {
              autoAlpha: 0,
              duration: 0,
              x: 0,
              ease: 'linear',
              stagger: 0.02,
            }),
          ],
          '<'
        );
      } else {
        this.animation.add([
          gsap.to(part, {
            autoAlpha: 1,
            duration: 0,
            x: 0,
            ease: 'linear',
            stagger: 0.02,
          }),
        ]);
      }
    }
  }

  reveal() {
    this.st = ScrollTrigger.create({
      animation: this.animation,
      trigger: this.DOM.view,
      start: 'top 80%',
    });
  }

  destroy() {
    this.st.kill(true);
  }
}
